'use client';;
import { Fragment } from 'react';
import Link from 'next/link';
import { makeStyles } from 'tss-react/mui';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import AddIcon from '@mui/icons-material/Add';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useAppContext } from '../contexts/app';
import SidebarActiveGroups from '../components/calendar/sidebar-active-groups';
import SidebarGroupActions from '../components/calendar/sidebar-group-actions';
import HeaderGroupsMobile from '../components/header-groups-mobile';

const useStyles = makeStyles()((theme) => ({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  withIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  header: {
    marginLeft: theme.spacing(2),
    marginBottom: 0,
  },
}));

const MobileDrawer = () => {
  const {
    mobileDrawerOpen: open,
    setMobileDrawerOpen: setOpen,
    loggedInUser,
    city,
  } = useAppContext();
  const cityName = city?.name;
  const { classes } = useStyles();

  return (
    <Drawer open={open} onClose={() => setOpen(false)}>
      <nav
        className={classes.list}
        role="presentation"
        onClick={() => setOpen(false)}
        onKeyDown={() => setOpen(false)}
      >
        <List>
          <ListItemButton component={Link} title="Add Event" href="/events/new">
            <ListItemText
              slotProps={{
                primary: { className: classes.withIcon },
              }}
            >
              <AddIcon className={classes.icon} />
              Add Event
            </ListItemText>
          </ListItemButton>
          {!loggedInUser && (
            <Fragment>
              <Divider />
              <Typography variant="h3" className={classes.header}>Groups</Typography>
              <List dense>
                <Box sx={{ px: 2, pb: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    Groups organize regular rides and share updates with members. Sign up to join a group{cityName ? ` in ${cityName}` : ''} and never miss a ride.
                  </Typography>
                </Box>
                <SidebarActiveGroups />
                <SidebarGroupActions />
              </List>
            </Fragment>
          )}
        </List>
        {loggedInUser && (
          <Fragment>
            <Divider />
            <Typography variant="h3" className={classes.header}>Groups</Typography>
            <HeaderGroupsMobile />
          </Fragment>
        )}
      </nav>
    </Drawer>
  );
};

export default MobileDrawer;
